import { useQuery } from '@tanstack/react-query';
import { getTotalUnpaidRakeback } from '@/services/rake/rake.service';
import { useMemo } from 'react';

const useRakeBackAmount = () => {
  const { data: rakeData, isLoading: isLoadingRakeBack } = useQuery({
    queryKey: ['rakeBackData'],
    queryFn: () => getTotalUnpaidRakeback(),
    staleTime: 60000, // Cache results for 1 minute
  });

  const rakebackAmount = useMemo(() => {
    const amount: number = rakeData?.data?.amount || 0;

    if (!amount) return amount.toFixed(2);

    return amount < 1 ? amount.toFixed(3) : amount.toFixed(2);
  }, [rakeData?.data?.amount]);
  return { isLoadingRakeBack, rakebackAmount };
};

export default useRakeBackAmount;
